import { defineStore } from 'pinia';

export const useTechStore = defineStore('tech', {
    state: () => ({
        userInfo: null,
    }),
    actions: {
        changeUserInfo(userInfo) {
            this.userInfo = userInfo;
        },
    }
});